import React from 'react';
import { FadeIn } from './FadeIn';
export const ProblemSection = () => {
  return <section className="py-20 bg-dark" data-id="element-157">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-158">
        <FadeIn data-id="element-159">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-160">
            El Problema{' '}
            <span className="text-brand-orange" data-id="element-161">Que Ya Conoces</span>
          </h2>
        </FadeIn>
        <FadeIn delay={0.2} data-id="element-162">
          <p className="text-xl text-gray-300 leading-relaxed" data-id="element-163">
            La mayoría de las mañanas empiezan igual: Te levantas con una niebla
            mental, sientes esa pesadez en el cuerpo, y el café ya no te da lo
            que antes te daba. Has probado desayunos rápidos que te dejan con
            hambre. Has intentado saltarte la comida y solo tomar un café, pero
            a media mañana estás sin energía. Y al final, esa falta de arranque
            te pasa factura en el trabajo y en casa.
          </p>
        </FadeIn>
      </div>
    </section>;
};